import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';

import { MasterToolListComponent } from './master-tool-list.component';

// Configuration
import { ConfigurationComponent } from './configuration/configuration.component';
import { BuildToolsComponent } from './configuration/build-tools/build-tools.component';
import { ConstructionIntegrationComponent } from './configuration/construction-integration/construction-integration.component';
import { FurnishedEquipmentToolsComponent } from './configuration/furnished-equipment-tools/furnished-equipment-tools.component';
import { LegacyToolsComponent } from './configuration/legacy-tools/legacy-tools.component';
import { SystemLayoutComponent } from './configuration/system-layout/system-layout.component';
import { WeldgunDesignComponent } from './configuration/weldgun-design/weldgun-design.component';

// Detail
import { DetailComponent } from './detail/detail.component';
import { CellsComponent } from './detail/cells/cells.component';
import { StationsComponent } from './detail/stations/stations.component';
import { ToolsComponent } from './detail/tools/tools.component';
import { KitsComponent } from './detail/kits/kits.component';
import { SystemLayoutsComponent } from './detail/system-layout/system-layout.component';
import { AssignToolsDialogComponent } from './detail/assign-tools-dialog/assign-tools-dialog.component';
import { ListComponent } from './list/list.component';
import { CopyToolsDialogComponent } from './list/copy-tools-dialog/copy-tools-dialog.component';

@NgModule({
    imports: [
        SharedModule,
    ],
    declarations: [
        MasterToolListComponent,
        ConfigurationComponent,
        BuildToolsComponent,
        ConstructionIntegrationComponent,
        FurnishedEquipmentToolsComponent,
        LegacyToolsComponent,
        SystemLayoutComponent,
        WeldgunDesignComponent,
        SystemLayoutsComponent,
        DetailComponent,
        CellsComponent,
        StationsComponent,
        ToolsComponent,
        KitsComponent,
        AssignToolsDialogComponent,
        ListComponent,
        CopyToolsDialogComponent,
    ],

})
export class CamtlMasterToolListModule { }
